import { Outlet, useNavigate } from 'react-router';
import SectionHeading from '@/components/SectionHeading';

export default function Settings() {
  const navigate = useNavigate();
  const tabs = [
    { name: 'Profile', path: 'profile', current: true },
    // { name: "Password", path: `${url}/password`, current: false },
    // {
    //   name: "Notifications",
    //   path: `${url}/notifications`,
    //   current: false,
    // },
    {
      name: 'Company Profile',
      path: 'company-profile',
      current: false,
    },
  ];

  return (
    <main className='flex-1 focus:outline-hidden relative max-w-screen-2xl mx-auto'>
      <div>
        <SectionHeading title='Settings' />
        <div className='bg-white'>
          <div className='lg:hidden p-6'>
            <label htmlFor='selected-tab' className='sr-only'>
              Select a tab
            </label>
            <select
              id='selected-tab'
              name='selected-tab'
              className='mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-hidden focus:ring-purple-500 focus:border-purple-500 sm:text-sm rounded-md'
            >
              {tabs.map((tab) => (
                <option key={tab.name} value={tab.path} onClick={() => navigate(tab.path)}>
                  {tab.name}
                </option>
              ))}
            </select>
          </div>
          {/* <div className="hidden lg:block">
                <div className="border-b border-gray-200">
                  <nav className="-mb-px flex space-x-8">
                    {tabs.map((tab) => (
                      <AppNavLink
                        key={tab.name}
                        to={tab.path}
                        baseClassName="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
                        activeClassName="border-primaryColor-normal"
                        inactiveClassName="border-transparent text-gray-500 hover:border-green-300 hover:text-gray-700"
                      >
                        {tab.name}
                      </AppNavLink>
                    ))}
                  </nav>
                </div>
              </div> */}
          <Outlet />
        </div>
      </div>
    </main>
  );
}
